import { render, staticRenderFns } from "./TFHero.vue?vue&type=template&id=f2b952de&scoped=true&"
import script from "./TFHero.vue?vue&type=script&lang=js&"
export * from "./TFHero.vue?vue&type=script&lang=js&"
import style0 from "./TFHero.vue?vue&type=style&index=0&id=f2b952de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b952de",
  null
  
)

export default component.exports